import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import transicon from "../../assets/img/transicon.png";
import transicon2 from "../../assets/img/transicon2.png";
import transicon3 from "../../assets/img/transicon3.png";
import transicon4 from "../../assets/img/transicon4.png";
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { removeTranslation } from "slices/translationSlice";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { usePermissions } from "layouts/Admin";
import { fetchClientTranslationsList } from "slices/mainAccount/ClientTranslationSlice";
import { clientTranslationSelector } from "slices/mainAccount/ClientTranslationSlice";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import { AsyncPaginate } from "react-select-async-paginate";
import { selectCustomStyles } from "components/common/Select";
import { Controller, useForm } from "react-hook-form";
import ErrorMessage from "components/common/ErrorMessage";
import moment from "moment";
import { LegendButton } from "components/common/TableColor";
import { fetchLanguages } from "slices/languageSlice";
import { languageSelector } from "slices/languageSlice";
import { filteredClientStatus } from "components/common/TableColor";

function ClientTranslation() {
  const dispatch = useDispatch();
  const { checkPermission } = usePermissions();
  const {
    clientTranslations,
    last_page: totalPages,
    loader,
    total,
    current_page,
    per_page: pageLength,
  } = useSelector(clientTranslationSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {},
  });
  const refAddutton = React.useRef(null);
  const navigate = useNavigate();
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([10]);
  const [translationPageLength, setTranslationPageLength] = useState(10);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: "id",
    sortDirection: "desc",
  });
  const { language: languages } = useSelector(languageSelector);
  
  // Disabled popup logic, now navigates to /add-translation
  const handleAddLanguagePopUp = () => {
    setTimeout(() => {
      navigate("/add-translation-form");
    }, 300);
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      });
      setSelectedItems([]);
      setSelectAll(false);
      dispatch(fetchClientTranslationsList());
      hideConfirmDialog();
    } else {
      toast.error(message, {
        className: "errorToast",
      });
    }
  };
  const [status, setStatusValue] = React.useState("all");

  const {
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    getValues,
    setError: setErrors,
    reset,
  } = useForm({
    defaultValues: {
      start_date: moment().format("YYYY/MM/DD"),
      end_date: moment().format("YYYY/MM/DD"),
      translator: null,
      client: null,
      source_language: null,
      target_language: null,
    },
  });
  
  const values = getValues();


  const allFilters = {
    start_date: values.start_date,
    end_date: values.end_date,
    status: status,
    translator: values.translator,
    client: values.client,
    source_language: values.source_language,
    target_language: values.target_language,
  };

  Object.keys(allFilters).forEach((key) => {
    if (!allFilters[key]) delete allFilters[key];
  });


  const showConfirmDialog = () => {
    setDeleteModal(true);
    return;
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  };
  const handleRemoveItems = () => {
    selectedItems.forEach((id) => {
      dispatch(removeTranslation(id, submitCallback));
    });
  };
  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value;
    setSelectedItems(
      selectedItems.includes(id)
        ? selectedItems.filter((item) => item != id)
        : [...selectedItems, id]
    );
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
      setSelectAll(false);
      return;
    }
    setSelectAll(true);
    setSelectedItems(
      clientTranslations?.map((translation) => translation.id.toString())
    );
  };

  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    dispatch(fetchClientTranslationsList(page));
  }, []);

  const handleClose = () => {
    refAddutton.current.click();
    setAddForm({ show: false });
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
  };

  //#region TABLE HEAD

  const renderTableHeader = React.useCallback(() => {
    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir });
      dispatch(
        fetchClientTranslationsList(currentPage, {
          sortBy: sortBy,
          sortDirection: dir,
          search: searchTerm,
        })
      );
    };
    return (
      <tr>
        <th className="table-col">#</th>
        <th className="table-col">TransID</th>
        <th className="table-col">Account</th>
        <th className="table-col">Source</th>
        <th className="table-col">Target</th>
        <th className="table-col">Requester</th>
        <th className="table-col">Status</th>
        <th className="table-col">Total Words Count</th>
        <th className="table-col">Est. Words Count</th>
        <th className="table-col">Total Est. Amount</th>
        <th className="table-col">Received Date</th>
        {/* <th className="col-2">Details</th> */}
      </tr>
    );
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

  //#endregion

  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    const safeTranslations = Array.isArray(clientTranslations?.data)
      ? clientTranslations.data
      : [];
    return safeTranslations.map((translation, index) => (
      <TranslationItem
        translation={translation}
        index={index}
        selectedItems={selectedItems}
        handleChange={handleChange}
        handleAddPopUp={handleAddLanguagePopUp}
        current_page={current_page}
        pageLength={pageLength}
        checkPermission={checkPermission}
        navigate={navigate}
      />
    ));
  }, [clientTranslations, selectedItems, navigate]);

  //#endregion

  // filteration Work

  // #region Target Language dropdown
  const [targetLanguageState, setTargetLanguageState] = React.useState([]);
  const [activeLegend, setActiveLegend] = React.useState(0);

  const startDateRef = React.useRef(null);
  const endDateRef = React.useRef(null);


  // Pills Filter Function Headers...
  const hanldeActiveLegend = (id, value) => {
    setActiveLegend(id);
    setStatusValue(value);

    const params = {
      start_date: values.start_date || moment().format("YYYY/MM/DD"),
      end_date: values.end_date || moment().format("YYYY/MM/DD"),
      status: value,
      translator: values.translator || null,
      client: values.client || null,
      source_language: values.source_language || null,
      target_language: values.target_language || null,
      pagelength: translationPageLength
    };

    Object.keys(params).forEach((key) => {
      if (params[key] === null || params[key] === "") {
        delete params[key];
      }
    });

    // API call
    dispatch(fetchClientTranslationsList(1, params));
  };

  React.useEffect(() => {
    dispatch(fetchClientTranslationsList(1, values));
  }, [dispatch]);

  // Source Language
  const [sourceLanguageState, setSourceLanguageState] = React.useState([]);

  React.useEffect(() => {
    const formValue = getValues("source_language_id");
    if (formValue && Array.isArray(formValue) && formValue.length > 0) {
      setSourceLanguageState(
        languages
          ?.filter((lang) => formValue.includes(lang.id))
          ?.map((val) => ({
            label: val?.name || "",
            value: val?.id || "",
          }))
      );
    }
  }, [languages, getValues]);

  const filteredLanguagesLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchLanguages(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result.data.map((item) => ({
        value: item.id,
        label: item.name,
      })),
      hasMore: page !== result?.last_page ? true : false,
      additional: {
        page: page + 1,
      },
    };
  };

  // Translation Cards
  const renderCards = () => {
    return (
      <>
        {/* Cards Section  */}
        <div className="d-flex w-100 gap-3" style={{ marginTop: "14px" }}>
          <div
            className="border p-3 flex-fill"
            style={{ borderRadius: "12px", backgroundColor: "#FFF" }}
          >
            <div className="d-flex mb-2 align-items-center justify-content-between">
              <span style={{ color: "#6C889C" }}>Total Projects</span>
              <img style={{ width: 24 }} src={transicon} alt="" />
            </div>
            <span
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                color: "#6C889C",
              }}
            >
              {clientTranslations?.total}
            </span>
          </div>

          <div
            className="border p-3 flex-fill"
            style={{ borderRadius: "12px", backgroundColor: "#FFF" }}
          >
            <div className="d-flex mb-2 align-items-center justify-content-between">
              <span style={{ color: "#6C889C" }}>Under Review</span>
              <img style={{ width: 24 }} src={transicon2} alt="" />
            </div>
            <span
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                color: "#6C889C",
              }}
            >
              {clientTranslations?.under_review}
            </span>
          </div>

          <div
            className="border p-3 flex-fill"
            style={{ borderRadius: "12px", backgroundColor: "#FFF" }}
          >
            <div className="d-flex mb-2 align-items-center justify-content-between">
              <span style={{ color: "#6C889C" }}>Completed</span>
              <img style={{ width: 24 }} src={transicon3} alt="" />
            </div>
            <span
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                color: "#6C889C",
              }}
            >
              {clientTranslations?.completed}
            </span>
          </div>

          <div
            className="border p-3 flex-fill"
            style={{ borderRadius: "12px", backgroundColor: "#FFF" }}
          >
            <div className="d-flex mb-2 align-items-center justify-content-between">
              <span style={{ color: "#6C889C" }}>Cancelled</span>
              <img style={{ width: 24 }} src={transicon4} alt="" />
            </div>
            <span
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                color: "#6C889C",
              }}
            >
              {clientTranslations?.cancelled}
            </span>
          </div>
        </div>
      </>
    );
  };

  const filteredStatus = React.useMemo(() => {
    const temp_array = [...filteredClientStatus];
    temp_array.unshift({
      value: "all",
      name: "All",
      id: 0,
      color: "#3176A0",
    });
    return temp_array;
  }, [filteredClientStatus]);

  // Filters onsubmit
  const onSubmit = (values) => {
    const params = {
      start_date: values.start_date
        ? moment(values.start_date).format("YYYY/MM/DD")
        : null,
      end_date: values.end_date
        ? moment(values.end_date).format("YYYY/MM/DD")
        : null,
      translator: values.translator ?? null,
      client: values.client ?? null,
      source_language: values.source_language ?? null,
      target_language: values.target_language ?? null,
      status: status ?? null,
      pagelength: translationPageLength
    };

    Object.keys(params).forEach((key) => {
      if (!params[key]) delete params[key];
    });

    dispatch(fetchClientTranslationsList(1, params));
  };

  // Reset function
  const handleResetFields = () => {
    reset({
      start_date: moment().format("YYYY/MM/DD"),
      end_date: moment().format("YYYY/MM/DD"),
      client: null,
      translator: null,
      source_language_id: null,
      target_language: null,
    });
    setTargetLanguageState(null);
    setSourceLanguageState(null);
    console.log("reset");
    dispatch(fetchClientTranslationsList({}));
  };

  // Filter section
  const renderFilters = () => {
    return (
      <>
        <div className="container-fluid">
          {/* Row 1 */}
          <div className="d-flex justify-content-start flex-wrap mb-4">
            {/* Status */}
            <LegendButton
              activeId={activeLegend}
              options={filteredStatus}
              handleClick={hanldeActiveLegend}
            />
          </div>

          {/* Row 2 */}
          <div className="row gx-4 gy-3 align-items-center">
            {/* Start Date */}
            <div className="col-12 col-md-4 d-flex align-items-center gap-3">
              <h2
                className="mb-0 form-label"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Start Date
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="start_date"
                  control={control}
                  render={({ field }) => (
                    <div className="input-image basic_bases">
                      <input
                        ref={startDateRef}
                        id="start_date"
                        type="date"
                        name="start_date"
                        placeholder="Start Date"
                        {...field}
                        value={
                          field.value
                            ? moment(field.value).format("YYYY-MM-DD")
                            : moment().format("YYYY-MM-DD") // fallback current date
                        }
                        onChange={(e) => {
                          const dateString = moment(
                            new Date(e.target.value)
                          ).format("YYYY/MM/DD");
                          field.onChange(dateString);
                        }}
                      />
                      <img
                        src="/images/celender.png"
                        alt="celender Icon"
                        className="custom-icon"
                      />
                    </div>
                  )}
                />
              </div>
            </div>

            {/* End Date */}
            <div className="col-12 col-md-4 d-flex align-items-center gap-3">
              <h2
                className="mb-0 form-label"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                End Date
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="end_date"
                  control={control}
                  render={({ field }) => (
                    <div className="input-image basic_bases">
                      <input
                        ref={endDateRef}
                        type="date"
                        name="end_date"
                        placeholder="End Date"
                        {...field}
                        value={
                          field.value
                            ? moment(field.value).format("YYYY-MM-DD")
                            : moment().format("YYYY-MM-DD")
                        }
                        onChange={(e) => {
                          const dateString = moment(
                            new Date(e.target.value)
                          ).format("YYYY/MM/DD");
                          field.onChange(dateString);
                        }}
                      />
                      <img
                        src="/images/celender.png"
                        alt="celender Icon"
                        className="custom-icon"
                      />
                    </div>
                  )}
                />
              </div>
            </div>

            {/* Source Language */}
            <div className="col-12 col-md-4 d-flex align-items-center gap-3">
              <h2
                className="mb-0 form-label text-wrap"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Source Language
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="source_language"
                  control={control}
                  defaultValue={null}
                  render={({ field }) => (
                    <div style={{ width: "100%" }}>
                      <div style={{ width: "100%" }}>
                        <AsyncPaginate
                          menuPlacement="auto"
                          styles={{
                            ...selectCustomStyles,
                          }}
                          value={sourceLanguageState}
                          loadOptions={filteredLanguagesLoadOptions}
                          isClearable
                          escapeClearsValue
                          onChange={(selected) => {
                            setSourceLanguageState(selected);
                            field.onChange(selected ? selected.value : null);
                          }}
                          additional={{
                            page: 1,
                          }}
                        />
                      </div>
                      {errors?.source_language_id?.message && (
                        <div style={{ marginBottom: 10 }}>
                          <ErrorMessage
                            text={errors?.source_language_id?.message}
                          />
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>
            </div>
          </div>

          {/* Row 3 */}
          <div className="row mt-1 gx-4 gy-3 align-items-center">
            {/* Target Language */}
            <div className="col-12 col-md-4 d-flex align-items-center gap-3">
              <h2
                className="mb-0 form-label text-wrap"
                style={{ width: "120px", flexShrink: 0, color: "#6C889C" }}
              >
                Target Language
              </h2>
              <div style={{ flex: 1 }}>
                <Controller
                  name="target_language"
                  control={control}
                  // rules={{ required: "Language must be specified" }}
                  defaultValue={null} // important for single-select
                  render={({ field }) => (
                    <div className="basic_bases">
                      <AsyncPaginate
                        menuPlacement="auto"
                        styles={{ ...selectCustomStyles }}
                        value={targetLanguageState} // should be a single option object or null
                        loadOptions={filteredLanguagesLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(selected) => {
                          // selected is an object or null in single-select mode
                          setTargetLanguageState(selected);
                          field.onChange(selected ? selected.value : null);
                        }}
                        onBlur={field.onBlur}
                        additional={{ page: 1 }}
                      />
                    </div>
                  )}
                />
              </div>
            </div>
          </div>

          {/* Buttons row */}
          <div className="d-flex justify-content-start gap-3 mt-3">
            <SubmitButton
              handleSubmit={() => handleSubmit(onSubmit)()}
              buttonType="button"
              btnText="Search"
              className={"green"}
            />
            <SubmitButton
              buttonType="button"
              className={"lightBlue"}
              btnText="Reset"
              handleSubmit={handleResetFields}
            />
          </div>
        </div>
      </>
    );
  };

  const fetchList = React.useCallback(
    (page, params) => async (dispatch) => {
      console.log("object", page, params, activeLegend);
      dispatch(fetchClientTranslationsList(page, { ...params }));
    },
    []
  );

  return (
    <ListLayout
      heading="Special Projects"
      time={true}
      title=""
      buttonTitle="Add Project"
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      addButtonDisabled={!checkPermission("Create Languages")}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      fetchList={fetchList}
      renderAddLink={(callback) => (
        // TODO add permission
        <Link to="/user/translation/create" className="main_button ml-4">
          {"Add Project"}
        </Link>
      )}
      renderFilters={renderFilters}
      renderCards={renderCards}
      paginationParams={allFilters}
      renderAddForm={null}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddLanguagePopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      pageLengthChange={setTranslationPageLength}
      noOfItems={total}
      searchPlaceholder="Search Projects ..."
      addformModal={false}
      sortConfig={sortConfig}
      disableBootstrap={true}
    >
      {deleteModal && (
        <ConfirmationModal
          onClose={hideConfirmDialog}
          isOpen={deleteModal}
          onConfirm={handleRemoveItems}
        />
      )}
    </ListLayout>
  );
}

const TranslationItem = ({
  translation,
  index,
  selectedItems,
  handleChange,
  current_page,
  pageLength,
}) => {
  const getBackgroundStyle = (status) => {
    switch (status) {
      case "Cancelled":
      case "Client Cancelled":
      case "Quote Rejected":
        return { background: "#FFF0F0" };
      case "Translator Declined":
        return { background: "#F7C8C5" };
      case "Under Review":
        return { background: "#f1ebff" };
      case "New Request":
        return { background: "#FFF1D4" };
      case "Completed":
        return { background: "#D2D5D5" };
      case "Quote Sent":
        return { background: "#D6E4EC" };
      case "Quote Approved":
        return { background: "#EBFEED" };
      case "Quote Revised":
        return { background: "#f4e9ff" };
      case "Invoice Sent":
        return { background: "#DDE1FE" };
      case "Translators Invited":
        return { background: "#CBD1DC" };
      case "Assigned":
        return { background: "#DCEBFE" };
      default:
        return { background: "#ffffff" };
    }
  };

  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);

  const statusMap = {
    "Translators Invited": "Invited",
    "Invoice Sent": "Submission Approved",
    "Client Cancelled": "Cancelled",
    "Quote Sent": "Quote Received",
  };

  return (
    <tr>
      <td style={getBackgroundStyle(translation?.status)}>
        <div className="row_check">
          <span>{serial}</span>
          <label className="custom-checkbox checkbox">
            <input
              type="checkbox"
              name="select-all"
              data-value={translation.id}
              checked={selectedItems.includes(translation.id.toString())}
              onChange={handleChange}
            />
            <span className="checkmark"></span>
          </label>
        </div>
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        <Link
          to={`/user/translation/view/${translation.id}`}
          style={{
            color: "#6F8DFF",
            cursor: "pointer",
            textDecoration: "underline",
            fontWeight: 500,
          }}
        >
          {translation.transid}
        </Link>
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {translation.accounts.user.name}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {translation.language?.name}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {Array.isArray(translation.translation_target_languages)
          ? translation.translation_target_languages
              .map((tl) => tl.language?.name)
              .join(", ")
          : ""}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {translation.requester_name}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {statusMap[translation.status] || translation.status}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {translation.total_words_count}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {translation.est_words_count}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {translation.total_amount !== undefined
          ? new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(
              translation.total_amount
            )
          : ""}
      </td>
      <td style={getBackgroundStyle(translation?.status)}>
        {new Date(translation.created_at).toISOString().slice(0,16).replace("T", " ")}
      </td>
      {/* <td style={getBackgroundStyle(status)}>
        <div className="row_check" style={{ position: "relative" }}>
          <DropdownActions
            onEdit={() => {
              navigate('/user/add-translation-form');
            }}
            onDelete={() => {
              // Select only this item for delete
              if (!selectedItems.includes(translation.id.toString())) {
                handleChange({
                  target: { dataset: { value: translation.id.toString() } },
                });
              }
              // Show delete modal
              document.dispatchEvent(new CustomEvent("showDeleteModal"));
            }}
          />
        </div>
      </td> */}
    </tr>
  );
};

export default ClientTranslation;
